/* eslint-disable no-nested-ternary */
import React from 'react'
import { Box } from '@usap/uicomponents'
import { TextWithStyle, Divider, BreadcrumbsContainer } from './style/TempBreadCrumbWMO.css'

export default function TempBreadcrumbWMO({
    links = [],
    Link = () => "",
    exitReturnDetails,
    isScroll = true,
}) {
    const length = links.length;

    if (length === 0) {
        return null
    }

    return (
        <BreadcrumbsContainer
            id="breadCrumbList"
            as="ul"
            className={isScroll ? "breadCrumbListScrollable" : ""}
        >
            {links.map((item, index) => {
                let maxLength = length === index + 1;
                return (
                    <Box
                        id={(item.name || item.text).replace(/ /g, "")}
                        key={item.name || item.text}
                        as="li"
                        direction="row"
                        align="center"
                        justify="center"
                    >
                        {maxLength ? (
                            <TextWithStyle
                                textAlign="center"
                                color="dark-2"
                                weight={maxLength ? "bold" : "normal"}
                                noPointer={maxLength}
                                size="14px"
                            >
                                {item.name || item.text}
                            </TextWithStyle>
                        ) : (
                            <>
                                {item.text === "Order Details" || item.text === 'Returns' ? (
                                    <TextWithStyle
                                        textAlign="center"
                                        color="dark-2"
                                        weight={maxLength ? "bold" : "normal"}
                                        noPointer={maxLength}
                                        size="14px"
                                        onClick={exitReturnDetails}
                                        itemProp="name"
                                        content={item.name || item.text}
                                        style={{ lineHeight: "23px" }}
                                    >
                                        {item.name || item.text}
                                    </TextWithStyle>
                                ) : (
                                    <Link
                                        to={item.link || item.url || item.value}
                                        style={{ lineHeight: '20px' }}
                                    >
                                        <TextWithStyle
                                            textAlign="center"
                                            color="dark-2"
                                            weight={maxLength ? "bold" : "normal"}
                                            noPointer={maxLength}
                                            size="14px"
                                            itemProp="name"
                                            content={item.name || item.text}
                                            style={{ lineHeight: "23px" }}
                                        >
                                            {item.name || item.text}
                                        </TextWithStyle>
                                    </Link>
                                )}
                            </>
                        )}

                        {!maxLength && (
                            <Divider>
                                |
                            </Divider>
                        )}
                    </Box>
                );
            })}
        </BreadcrumbsContainer>
    );
}
